import { useState, useEffect } from "react";
import { api } from "./api";

export default function ModalAssigner({ T, ticket, onClose, onAssigned }) {
  const [techniciens, setTechniciens] = useState([]);
  const [selected, setSelected] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getTechniciens().then(tc => setTechniciens(Array.isArray(tc)?tc:[]));
  }, []);

  const handleAssign = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      const res = await fetch(`https://support.gs-group.fr/api/tickets/${ticket.id}/assigner`, {
        method: "PATCH",
        headers: { "Content-Type":"application/json", Authorization:`Bearer ${localStorage.getItem("nexo_token")}` },
        body: JSON.stringify({ technicien_id: selected }),
      }).then(r=>r.json());
      onAssigned && onAssigned(res);
      onClose();
    } catch(e) {}
    setSaving(false);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",backdropFilter:"blur(6px)",zIndex:1100,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:440}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>👤 Assigner un technicien</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>{ticket?.titre||ticket?.objet}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:20}}>✕</button>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
          {techniciens.length===0
            ? <div style={{textAlign:"center",padding:20,color:T.muted}}>Aucun technicien disponible</div>
            : techniciens.map(t=>(
              <div key={t.id} onClick={()=>setSelected(t.id)}
                style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",borderRadius:11,border:`1.5px solid ${selected===t.id?T.accent:T.border}`,background:selected===t.id?T.accentDim:"transparent",cursor:"pointer",transition:"all 0.15s"}}>
                <div style={{width:38,height:38,borderRadius:"50%",background:`${T.accent}22`,border:`1.5px solid ${T.accent}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,color:T.accent,flexShrink:0}}>
                  {t.prenom[0]}{t.nom[0]}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:selected===t.id?T.accent:T.text}}>{t.prenom} {t.nom}</div>
                  <div style={{fontSize:11,color:T.muted}}>📞 {t.telephone||"—"}</div>
                </div>
                {selected===t.id&&<div style={{width:20,height:20,borderRadius:"50%",background:T.accent,display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{width:7,height:7,borderRadius:"50%",background:"#fff"}}/></div>}
              </div>
            ))
          }
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>Annuler</button>
          <button onClick={handleAssign} disabled={!selected||saving}
            style={{flex:2,padding:"11px",borderRadius:10,background:selected?T.accent:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:selected?"pointer":"not-allowed",opacity:saving?0.7:1}}>
            {saving?"Assignation...":"✓ Assigner"}
          </button>
        </div>
      </div>
    </div>
  );
}
